import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox';
import { MailGreen } from '../../assets/images/index.js';

export default class ArticleGridItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      photoIndex: 0,
      isOpen: false
    };
  }
  render() {
    const { isOpen } = this.state;
    return (
      <div className={'swiper-slide grid-item  ' + this.props.className}>
        <div
          className="grid-item__img swiper-lazy"
          data-background={this.props.imageSrc} onClick={() => this.setState({ isOpen: true })}>
          <div className="swiper-lazy-preloader" />
        </div>
        {this.props.title && (
          <div className="grid-item__title">{this.props.title}</div>
        )}
        {this.props.content && (
          <div className="grid-item__content">{this.props.content}</div>
        )}
        {this.props.link && (
          <a href={`mailto:${this.props.link}`} className="grid-item__link">
            <MailGreen />&nbsp;{this.props.link}
          </a>
        )}
        {isOpen && (
          <Lightbox
            mainSrc={this.props.imageSrcHq}
            onCloseRequest={() => this.setState({ isOpen: false })}
          />
        )}
      </div>
      
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ArticleGrid/ArticleGridItem.jsx